// ============================================
// RYSMIDE — GALLERY FIX
// Smooth image switching + mobile touch fix
// ============================================
(function () {
  'use strict';

  // --- Inject CSS ---
  // Replace display:none/block switching with opacity transitions
  // touch-action: manipulation prevents scroll-swipe from stealing thumb clicks
  var css = [
    '.ywp-main{position:relative!important}',
    '.ywp-main img{position:absolute!important;top:0!important;left:0!important;width:100%!important;height:100%!important;object-fit:cover!important;display:block!important;opacity:0;transition:opacity .3s ease;pointer-events:none}',
    '.ywp-main img.gf-active{opacity:1!important}',
    '.ywp-thumbs button{touch-action:manipulation;-webkit-tap-highlight-color:transparent;cursor:pointer!important}',
    '.ywp-thumbs button.is-active{border-color:var(--yw-primary)!important}'
  ].join('');

  var styleTag = document.createElement('style');
  styleTag.id = 'gallery-fix-styles';
  styleTag.textContent = css;
  document.head.appendChild(styleTag);

  function initGallery() {
    var gallery = document.querySelector('.ywp-gallery');
    if (!gallery || gallery._gfInit) return;
    gallery._gfInit = true;

    var mainImgs = Array.prototype.slice.call(gallery.querySelectorAll('.ywp-main img'));
    var thumbBtns = Array.prototype.slice.call(gallery.querySelectorAll('.ywp-thumbs button'));

    if (!mainImgs.length || !thumbBtns.length) return;

    var current = 0;

    function showImage(idx) {
      current = ((idx % mainImgs.length) + mainImgs.length) % mainImgs.length;

      mainImgs.forEach(function (img, i) {
        img.classList.toggle('gf-active', i === current);
      });

      thumbBtns.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === current);
      });

      // Scroll active thumb into view (for horizontal strip)
      var activeThumb = thumbBtns[current];
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    // Initialize first image
    showImage(0);

    // Thumb button handlers (click + touchend for mobile)
    thumbBtns.forEach(function (btn, i) {
      btn.addEventListener('click', function (e) {
        showImage(i);
      });

      btn.addEventListener('touchend', function (e) {
        e.preventDefault(); // prevent ghost click
        showImage(i);
      }, { passive: false });
    });

    // Arrow button handlers
    var arrowNext = gallery.querySelector('.ywp-arrow--next');
    var arrowPrev = gallery.querySelector('.ywp-arrow--prev');

    if (arrowNext) {
      arrowNext.addEventListener('click', function () { showImage(current + 1); });
      arrowNext.addEventListener('touchend', function (e) {
        e.preventDefault();
        showImage(current + 1);
      }, { passive: false });
    }

    if (arrowPrev) {
      arrowPrev.addEventListener('click', function () { showImage(current - 1); });
      arrowPrev.addEventListener('touchend', function (e) {
        e.preventDefault();
        showImage(current - 1);
      }, { passive: false });
    }

    // Swipe support on main image (mobile gesture)
    var touchStartX = null;
    var mainEl = gallery.querySelector('.ywp-main');
    if (mainEl) {
      mainEl.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      mainEl.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(dx) > 40) {
          showImage(dx < 0 ? current + 1 : current - 1);
        }
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }
})();
// ============================================
// END GALLERY FIX
// ============================================
